<div class="dam">
  <div class="dam__center" [ngClass]="{'active': productShow}">
    <div class="dam__center-block">
      <div class="dam__center-title">
        <h1>Корзина</h1>
        <div *ngIf="selected.size>0">Выбрано: {{ selected.size }}
        </div>
      </div>
      <div class="dam__center-content">


        <div class="tabs-title">
          <div class="tab-item" (click)="showProductBlocks('table')" [ngClass]="{'active': isShowProductTable}" i18n-nbTooltip="@@BigThumbnails" nbTooltip="Большие миниатюры">
            <nb-icon icon="grid-outline"/>
          </div>
          <div class="tab-item" (click)="showProductBlocks('more')" [ngClass]="{'active': isShowProductTableMore}" i18n-nbTooltip="@@Thumbnails" nbTooltip="Миниатюры">
            <nb-icon icon="keypad-outline"/>
          </div>
          <div class="tab-item" (click)="showProductBlocks('list')" [ngClass]="{'active': isShowProductList}" i18n-nbTooltip="@@TableView" nbTooltip="Отображать таблицей">
            <nb-icon icon="menu-outline"/>
          </div>
        </div>

        <div class="dam__sort" *ngIf="pagination">
          <nb-select placeholder="Сортировка" size="small" (selectedChange)="changeSort($event)" i18n-nbTooltip="@@Sorting" nbTooltip="Сортировка"
                     [selected]="pagination.order + '_' + pagination.direction">
            <nb-option value="header_asc">Название: A -> Z</nb-option>
            <nb-option value="header_desc">Название: Z -> A</nb-option>
            <nb-option value="createdAt_asc">Старые</nb-option>
            <nb-option value="createdAt_desc">Новые</nb-option>
            <nb-option value="updatedAt_desc">Измененные</nb-option>
          </nb-select>
        </div>
      </div>
    </div>
    <div class="count-file">{{ totalElements }} шт.</div>

    <div class="content-tabs">
      <div>
        <div class="productList">
          <div class="productList__table">
            <div class="productList__row" *ngFor="let product of productList | async | paginate: paginationConfig">

              <div class="productList__title">
                <img src="/assets/images/dam/vivid/{{product.icon}}.svg" alt="" style="width:20px"> {{ product.header }}
              </div>
              <div class="productList__changes">
                <p>Перемещено в корзину: {{ product.deletedAt | date: 'dd.MM.yyyy HH:mm' }}</p>
              </div>
              <div class="productList__icon">
              </div>
              <div class="productList__more" [matMenuTriggerFor]="menu">
                <img src="/assets/images/dam/more-icon.svg" alt="">
              </div>
              <mat-menu #menu="matMenu">
                <app-dam-content [data]="product"
                                 (changeInfo)="showProductInfo(product.id, product.isImage, $event, product.countVersion)"></app-dam-content>
              </mat-menu>
            </div>
          </div>
        </div>
      </div>


    </div>


  </div>
  <div class="dam__right" [ngClass]="{'content': true, 'active': productShow}">
    <div class="active content-animation">
      <div class="dam__product" *ngIf="damElasticDTO!=null">
        <div class="dam__product-close" (click)="hideProductInfo()">
          <img src="/assets/images/header/menu-close.svg" alt="" class="menu-close">
        </div>

        <div class="dam__product-photo">
          <!-- <div class="star__icon">
             <app-dam-favorites></app-dam-favorites>
           </div> -->
          <img src="/assets/images/dam/doc.png" *ngIf="!damElasticDTO.isImage"/>

          <app-secured-image *ngIf="damElasticDTO.isImage"
                             src="/dam/get-image-dynamic/{{damElasticDTO.id}}/304"></app-secured-image>


        </div>
        <div class="title">{{ damElasticDTO.header }}</div>
        <nb-tabset>
          <nb-tab tabTitle="Инфо">
            <div class="tabs__content">
              <div class="info">

                <nb-tag-list (tagRemove)="onTagRemove($event)">
                  <nb-tag removable *ngFor="let tree of damElasticDTO.rolesAndUsersRead" [text]="tree"></nb-tag>
                </nb-tag-list>
              </div>

              <div class="info">
                <div class="title">Теги</div>
                <div class="tags-content">
                  <ng-container *ngIf="damElasticDTO?.terms?.length">
                    <nb-tag-list>
                      <nb-tag *ngFor="let term of damElasticDTO.terms" [text]="term.header"></nb-tag>
                      <!--
                       <div class="add" (click)="openModalPopup()">
                         <img src="/assets/images/dam/plus2.svg" alt="">
                       </div>
                       -->
                    </nb-tag-list>
                  </ng-container>

                  <ng-container *ngIf="!damElasticDTO?.terms?.length">нет</ng-container>
                </div>
              </div>
              <div class="tabs__info">
                <div class="tabs__title">
                  Количество версий
                </div>

                <div class="tabs__title-item">{{ damElasticDTO?.countVersion }}</div>
              </div>
              <div class="tabs__info">
                <div class="tabs__title">
                  Дата создания
                </div>
                <div class="tabs__title-item">{{ damElasticDTO?.createdAt | date: 'dd.MM.yyyy HH:mm' }}</div>
              </div>
              <div class="tabs__info">
                <div class="tabs__title">
                  Изменено
                </div>
                <div class="tabs__title-item">{{ damElasticDTO?.updatedAt | date: 'dd.MM.yyyy HH:mm' }}</div>
              </div>
              <div class="tabs__info" *ngIf="damElasticDTO?.manager != null">
                <div class="tabs__title">
                  Автор
                </div>
                <div class="tabs__author">
                  <div class="tabs__photo">
                    <img style="width:30px" *ngIf="damElasticDTO?.manager?.picture !== null"
                         [src]="getImageUri(damElasticDTO?.manager?.picture)" alt="">
                  </div>
                  {{ damElasticDTO?.manager?.lastName }} {{ damElasticDTO?.manager?.firstName }}
                </div>
              </div>

              <!--
              <div class="tabs__info">
                <div class="tabs__comment">
                  Комментарии
                </div>
                <textarea
                  value="Файл содержит подробные ответы на часто задаваемые вопросы о процессе авторизации на нашем сайте. Это ценный ресурс для наших пользователей, помогающий им "></textarea>
              </div>
              -->
            </div>


          </nb-tab>
          <!--
          <nb-tab tabTitle="История действий">
            <div class="action-history">
              <div class="action-history__title">
                История изменений файла
              </div>
              <div class="action-history__count">
                Всего 25 действий
              </div>
              <div class="action-history__list">
                <div class="action-history__item">
                  <div class="action-history__item-photo">
                    <img src="/assets/images/dam/avatar.jpg" alt="">
                  </div>
                  <div class="action-history__item-text">
                    <p>Изменение файла</p>
                    <div class="date">03.11.2026 16:50</div>
                  </div>
                </div>
              </div>

            </div>
          </nb-tab>
          -->
        </nb-tabset>

        <div class="info">
          <a target="_blank" href="/cabinet/dam/item/edit/{{damElasticDTO.id}}">Подробно</a>
        </div>


        <!--        <div class="info">-->
        <!--          <div class="title">Занимает</div>-->
        <!--          <div class="subtitle">- мб</div>-->
        <!--        </div>-->
        <!--        <div class="info">-->
        <!--          <div class="title">Изменено</div>-->
        <!--          <div class="subtitle">17 ноября 2023 г. автор последних изменений: я</div>-->
        <!--        </div>-->
        <!--        <div class="info">-->
        <!--          <div class="title">Комментарии</div>-->
        <!--          <textarea placeholder="Текст"></textarea>-->
        <!--        </div>-->

      </div>
    </div>
  </div>
</div>

<pagination
  [id]="paginationConfig.id"
  [config]="configuration"
  [pagination]="pagination"
  (update)="onPagination($event)"
/>
